import { Col, Row, Select } from "antd";
import { GET_STRIKE_SURFACES_END_POINT } from "api/volSurfaceApi";
import { STRIKE_SURFACES_QUERY_KEY } from "constants/queries";
import { GlobalContext } from "contexts/GlobalContext";
import useFetchData from "hooks/useFetchData";
import { useContext, useEffect, useState } from "react";

function StickyDeltaSurface({ setSelectedFilters, selectedFilters }) {
  const [selectedSurface, setSelectedSurface] = useState(null);

  const {
    globalState: { dark_Theme },
  } = useContext(GlobalContext);

   const { data, isLoading } = useFetchData({
     url: GET_STRIKE_SURFACES_END_POINT,
     queryKey: [STRIKE_SURFACES_QUERY_KEY, selectedFilters?.product_id],
     enabled: selectedFilters?.product_id !== undefined,
     params: {
       product_contract_style_id: selectedFilters?.product_id,
     },
   });

    const strikeSurfaces = data?.data?.data;


  function handleSelectChange(value) {
    setSelectedFilters((prev) => ({
      ...prev,
      sticky_surface: {
        id: value,
        label: strikeSurfaces.find((item) => item.id === value)?.title,
        product_id: selectedFilters?.product_id,
      },
    }));
  }

  useEffect(() => {
    if (!strikeSurfaces) return;
    const surface = strikeSurfaces?.find(
      (item) => item.id === selectedFilters?.sticky_surface?.id
    );
    setSelectedSurface(surface);
  }, [strikeSurfaces, selectedFilters?.sticky_surface?.id]);

  return (
    <Col span={24}>
      <Row gutter={[25, 25]}>
        <Col span={3}>Set Sticky Strike Surface:</Col>
        <Col>
          <Select
            placeholder="Select Surface"
            className={dark_Theme ? "select-dark" : ""}
            popupClassName={dark_Theme ? "dropdown-dark" : ""}
            style={{ width: 180 }}
            allowClear
            value={selectedSurface?.title}
            disabled={isLoading}
            loading={isLoading}
            onChange={(e) => {
              handleSelectChange(e);
            }}
            showSearch
            filterOption={(input, option) => {
              const inputSmallLetter = input.toLowerCase();
              const label = option.label.toLowerCase();
              return label.includes(inputSmallLetter);
            }}
            options={strikeSurfaces?.map((data) => ({
              value: data.id,
              label: data.title,
            }))}
          />
        </Col>
      </Row>
    </Col>
  );
}

export default StickyDeltaSurface;
